const SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";

export { SUPPRESS_TRACING_KEY };
//# sourceMappingURL=constants.js.map
